export const Resources = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.300049 13.5C0.300049 13.1134 0.613449 12.8 1.00005 12.8H15C15.3866 12.8 15.7 13.1134 15.7 13.5C15.7 13.8866 15.3866 14.2 15 14.2H1.00005C0.613449 14.2 0.300049 13.8866 0.300049 13.5Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.65152 1.65147C1.87656 1.42643 2.18179 1.3 2.50005 1.3H8.50005C8.81831 1.3 9.12353 1.42643 9.34858 1.65147C9.57362 1.87652 9.70005 2.18174 9.70005 2.5V13.5C9.70005 13.8866 9.38665 14.2 9.00005 14.2C8.61345 14.2 8.30005 13.8866 8.30005 13.5V2.7H2.70005V13.5C2.70005 13.8866 2.38665 14.2 2.00005 14.2C1.61345 14.2 1.30005 13.8866 1.30005 13.5V2.5C1.30005 2.18174 1.42648 1.87651 1.65152 1.65147Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.30005 6C8.30005 5.6134 8.61345 5.3 9.00005 5.3H13.5C13.8183 5.3 14.1235 5.42643 14.3486 5.65147C14.5736 5.87652 14.7 6.18174 14.7 6.5V13.5C14.7 13.8866 14.3866 14.2 14 14.2C13.6134 14.2 13.3 13.8866 13.3 13.5V6.7H9.00005C8.61345 6.7 8.30005 6.3866 8.30005 6Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.30005 4.5C3.30005 4.1134 3.61345 3.8 4.00005 3.8H6.00005C6.38665 3.8 6.70005 4.1134 6.70005 4.5C6.70005 4.8866 6.38665 5.2 6.00005 5.2H4.00005C3.61345 5.2 3.30005 4.8866 3.30005 4.5Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.30005 8.5C4.30005 8.1134 4.61345 7.8 5.00005 7.8H7.00005C7.38665 7.8 7.70005 8.1134 7.70005 8.5C7.70005 8.8866 7.38665 9.2 7.00005 9.2H5.00005C4.61345 9.2 4.30005 8.8866 4.30005 8.5Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.30005 11C3.30005 10.6134 3.61345 10.3 4.00005 10.3H6.00005C6.38665 10.3 6.70005 10.6134 6.70005 11C6.70005 11.3866 6.38665 11.7 6.00005 11.7H4.00005C3.61345 11.7 3.30005 11.3866 3.30005 11Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3 11C10.3 10.6134 10.6134 10.3 11 10.3H12C12.3866 10.3 12.7 10.6134 12.7 11C12.7 11.3866 12.3866 11.7 12 11.7H11C10.6134 11.7 10.3 11.3866 10.3 11Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3 8.5C10.3 8.1134 10.6134 7.8 11 7.8H12C12.3866 7.8 12.7 8.1134 12.7 8.5C12.7 8.8866 12.3866 9.2 12 9.2H11C10.6134 9.2 10.3 8.8866 10.3 8.5Z"
        fill="#706A85"
      />
    </svg>
  );
};
